module.exports = __webpack_public_path__ + "img/bm02.2da227a3.png";